import { Location, LocationState } from 'history'
import { ReactNode } from 'react'

export enum AppAction {
    SetBreadcrumbs = 'APP_SET_BREADCRUMBS',
    SetVersion = 'APP_SET_VERSION',
    DispatchCommand = 'APP_DISPATCH_COMMAND',
    AcknowledgeCommand = 'APP_ACKNOWLEDGE_COMMAND',
    LogOut = 'APP_LOGOUT',
    Reset = 'APP_RESET',
}

export interface IBackgroundLocationState<S = LocationState> {
    background: Location
    data?: S
}

export type InheritablePropsWithChildren<P> = {
    children?: (parentProps: P) => ReactNode
}

export enum Command {
    AddNote = 'add-note',
    AddTask = 'add-task',
    AddTime = 'add-time',
    TrackTime = 'track-time',
    SearchFile = 'search-file',
    SearchParty = 'search-party',
}

export enum AppContext {
    Command = 'command',
    Module = 'module',
    Read = 'read',
    Compose = 'compose',
    None = 'none',
}

export type EntityDto = {
    id: string
}
